

































import { AdgroupFormData, CampaignFormData, AdgroupConfig } from '@tt4b/ttam-enums';
import { computed, defineComponent, PropType, ref, toRefs } from '@vue/composition-api';
import { useShowBatchEditText, useFieldMixed, useShowBatchEditModal } from './hooks';
import BatchSettingModal from '../batch-setting-modal/index.vue';

const name = 'ttam-copy-batch-wrap';
export default defineComponent({
  name,
  components: {
    BatchSettingModal,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    batchFormData: {
      type: Array as PropType<Partial<AdgroupFormData>[]>,
      default: () => [],
    },
    countryIds: {
      type: Array as PropType<string[] | number[]>,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    fields: {
      type: Array as PropType<(keyof AdgroupFormData)[]>,
      default: () => [],
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { batchEditFields, batchEditModalVisible, batchEditLabel, openBatchEditor, closeBatchEditor } =
      useShowBatchEditModal();
    const { fields, adgroupData, batchFormData, adgroupConfig } = toRefs(props);

    const { isShowBatchEdit } = useShowBatchEditText({
      showBatchEdit: ref(adgroupConfig.value.showBatchEdit),
      copyNum: ref(batchFormData.value.length),
    });

    const { isFieldMixed } = useFieldMixed({
      fields,
      adgroupData,
      batchFormData,
    });

    const handleBatchEditClick = () => {
      openBatchEditor(props.fields, props.label);
    };

    const onAdgroupDataChange = data => {
      emit('adgroupDataChange', data);
    };

    const onCopyDataChange = data => {
      emit('copyDataChange', data);
    };

    return {
      name,
      isShowBatchEdit,
      isFieldMixed,
      handleBatchEditClick,
      onAdgroupDataChange,
      onCopyDataChange,
      batchEditFields,
      batchEditModalVisible,
      batchEditLabel,
      openBatchEditor,
      closeBatchEditor,
    };
  },
});
